// import { SiWix } from "react-icons/si";
import { TbSeo } from "react-icons/tb";
// import { SiShopify } from "react-icons/si";
// import { SiAmazonaws } from "react-icons/si";
import { BsCart3 } from 'react-icons/bs';
// import { FaDatabase } from "react-icons/fa";
// import { SiHtml5 } from "react-icons/si";
import { RiComputerLine } from 'react-icons/ri';
import { FaMobileAlt } from 'react-icons/fa';
import { SiAdobeillustrator } from 'react-icons/si';
// import { SiAmazon } from 'react-icons/si';
// import { SiDjango } from 'react-icons/si';
import { Gi3DMeeple } from 'react-icons/gi';
export const services = [
  {
    iconName: SiAdobeillustrator,
    title: " AI technology",
    text: "NajamTech AI is at the forefront of AI technology, providing cutting-edge solutions for businesses in a wide range of industries.",
  },
  {
    iconName: FaMobileAlt,
    title: "App development",
    text: "We specialize in mobile app development with a focus on delivering a seamless UI/UX experience for our clients and their users.",
  },
  {
    iconName: RiComputerLine ,
    title: "Web development",
    text: "We offers end-to-end web development services, from custom website design to full-stack development and maintenance.",
  },
  {
    iconName: Gi3DMeeple,
    title: "3D Model",
    text: "We create high-quality models, renderings, and animations that meet the needs of clients across a wide range of industries.",
  },
  {
    iconName: TbSeo,
    title: "SEO",
    text: "We provide SEO services, helping businesses achieve higher search engine rankings and increased visibility online.",
  },
 
  
  {
    iconName:  BsCart3 ,
    title: "Ecommerce sites",
    text: "We offer that services development using popular platforms like Shopify, Wix & WordPress to help businesses create online stores quickly.",
  },
  // {
  //   iconName: SiWix,
  //   title: "Sed ut perspiciatis",
  //   text: "Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi",
  // },
  // {
  //   iconName:  SiShopify,
  //   title: "Sed ut perspiciatis",
  //   text: "Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi",
  // },
  // {
  //   iconName: SiHtml5,
  //   title: "Divera don",
  //   text: "Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi",
  // },
  // {
  //   iconName: SiAmazonaws,
  //   title: "Lorem Ipsum",
  //   text: "Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi",
  // },
 
  // {
  //   iconName: SiDjango ,
  //   title: "Sed ut perspiciatis",
  //   text: "Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi",
  // },
,
];
